import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getLichHocAnh(payload: {
    page: number;
    limit: number;
    cond?: any;
  }) {
    return axios.get(`${ip3}/lich-hoc-anh/pageable`, {
      params: {
        ...payload,
        cond: {
          ...payload.cond,
        },
      },
    });
}

export async function getLop(payload: any) {
  const {idDonVi} = payload
  return axios.get(`${ip3}/don-vi/pageable/my/child/v2`, {
    params: { cond: { parent: idDonVi, loaiDonVi: 'Lop' } },
  });
}

export async function addLichHocAnh(payload: any) {
  return axios.post(`${ip3}/lich-hoc-anh`, payload);
}

export async function editLichHocAnh(payload: any) {
  const { id } = payload
  return axios.put(`${ip3}/lich-hoc-anh/${id}`, payload)
}

export async function delLichHocAnh(payload: any) {
  const { id } = payload
  return axios.delete(`${ip3}/lich-hoc-anh/${id}`)
}